import React, { useEffect, useState, Fragment } from 'react';
import { ShieldIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/rvX61FSTSXRtWcXvGnJkpT/ChatGPT-Image-14-jul-2026_-08_19_46-p.m..webp';
const CHECKOUT_URL = 'https://gymnastique-pro.impultienda.ar/checkout';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(previous => {
        let {
          hours,
          minutes,
          seconds
        } = previous;
        if (seconds > 0) seconds -= 1;else if (minutes > 0) {
          minutes -= 1;
          seconds = 59;
        } else if (hours > 0) {
          hours -= 1;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 45;
          seconds = 30;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units = [{
    value: timeLeft.hours,
    label: 'HEURES'
  }, {
    value: timeLeft.minutes,
    label: 'MINUTES'
  }, {
    value: timeLeft.seconds,
    label: 'SECONDES'
  }];
  return <section id="pricing" className="py-6 px-4 sm:px-6 bg-brand-ivory border-y-4 border-brand-gold/40 scroll-mt-2" data-id="element-119">
      <div className="text-center mb-4" data-id="element-120">
        <p className="text-sm font-heading font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-121">
          OFFRE SPÉCIALE — SYSTÈME COMPLET 6-EN-1
        </p>
        <p className="text-sm sm:text-base font-bold text-brand-navy mb-3 leading-snug max-w-md mx-auto" data-id="element-122">
          Accédez dès aujourd'hui au système qui transformera votre façon de
          préparer et d'enseigner vos entraînements de gymnastique artistique.
        </p>
        <div className="inline-block bg-brand-navy text-white px-4 py-2 rounded-md shadow-sm mb-3" data-id="element-123">
          <p className="font-heading font-bold text-sm tracking-wide" data-id="element-124">
            🤸 GYMNASTIQUE PRO™
          </p>
          <p className="text-xs font-bold mt-1 leading-snug" data-id="element-125">
            Le Système Complet de Planification 6-en-1 pour les Professeurs de
            Gymnastique Artistique
          </p>
        </div>
        <a href="#pricing" className="block cursor-pointer" aria-label="Voir l'offre Gymnastique Pro" data-id="element-126">
          <img src={PRODUCT_IMG} alt="Coffret numérique GYMNASTIQUE PRO, système complet de planification 6-en-1" className="w-full max-w-[310px] mx-auto object-contain drop-shadow-xl mb-3 hover:scale-[1.02] transition-transform" data-id="element-127" />
        </a>
      </div>
      <div className="bg-white border-4 border-brand-gold rounded-xl p-4 text-center relative mb-3 shadow-2xl" data-id="element-128">
        <div className="mb-3" data-id="element-129">
          <p className="text-sm font-bold text-brand-muted mb-1" data-id="element-130">
            Prix habituel : <span className="line-through" data-id="element-131">97 €</span>
          </p>
          <p className="text-sm font-heading font-bold text-red-600 mb-2 uppercase tracking-wide leading-tight" data-id="element-132">
            🔥 OFFRE DE LANCEMENT — 72 % DE RÉDUCTION
          </p>
          <p className="text-sm font-bold text-brand-navy uppercase tracking-wide" data-id="element-133">
            Aujourd'hui seulement :
          </p>
          <p className="text-6xl font-heading font-extrabold text-brand-navy mb-1 leading-none" data-id="element-134">
            27 €
          </p>
          <p className="text-xs font-bold text-brand-muted uppercase tracking-wider mt-2" data-id="element-135">
            Payez en toute sécurité dans votre devise locale.
          </p>
        </div>
        <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4" data-id="element-136">
          <p className="text-sm font-bold text-red-600 mb-2 leading-tight" data-id="element-137">
            🔥 Attention : cette offre spéciale disparaîtra lorsque le compteur
            atteindra zéro.
          </p>
          <div className="flex justify-center gap-2.5" data-id="element-138">
            {units.map((unit, index) => <Fragment key={unit.label} data-id="element-139">
                {index > 0 && <div className="text-xl font-bold text-brand-navy mt-1" data-id="element-140">
                    :
                  </div>}
                <div className="text-center" data-id="element-141">
                  <div className="bg-brand-navy text-white text-xl font-heading font-bold px-3 py-1.5 rounded-md shadow-inner leading-none" data-id="element-142">
                    {String(unit.value).padStart(2, '0')}
                  </div>
                  <p className="text-[9px] font-bold text-brand-text mt-1 tracking-wider" data-id="element-143">
                    {unit.label}
                  </p>
                </div>
              </Fragment>)}
          </div>
        </div>
        <CTAButton href={CHECKOUT_URL} data-id="element-144">
          🚀 OUI ! JE VEUX MON SYSTÈME COMPLET 6-EN-1
        </CTAButton>
      </div>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-1.5 sm:gap-5 text-xs sm:text-sm text-brand-text font-bold" data-id="element-145">
        <div className="flex items-center gap-1.5" data-id="element-146">
          <StarIcon className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-147" />
          <span data-id="element-148">
            4,9/5 — Avis vérifiés de professeurs de gymnastique artistique
          </span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-149">
          <ShieldIcon className="w-4 h-4 text-brand-violet" data-id="element-150" />
          <span data-id="element-151">
            Garantie satisfait ou remboursé pendant 7 jours — Zéro risque
          </span>
        </div>
      </div>
    </section>;
}